import Vue from "vue";
import HighchartsVue from "highcharts-vue";
Vue.use(HighchartsVue);
